import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../../theme';
import { HowItWorksStep } from '../types/landing';
import { BulletList } from './BulletList';

interface StepCardProps {
  step: HowItWorksStep;
}

export const StepCard: React.FC<StepCardProps> = ({ step }) => {
  return (
    <Box
      sx={{
        backgroundColor: colors.pureWhite,
        borderRadius: '12px',
        padding: '24px',
        border: `1px solid ${colors.slate[200]}`,
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          color: colors.deepNavy,
          marginBottom: '12px',
          fontSize: '1.125rem',
        }}
      >
        {step.number}. {step.title}
      </Typography>
      <BulletList items={step.bullets} color="slate600" />
    </Box>
  );
};
